import React from 'react';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import { BwjButtonType } from '../../../../framework/components/bwj-button';
import { xlate, xlationContext } from '../../../../framework/utils/i18n';
import { ITimingSpecComponentModel } from '../../../markdown/parser/timing-spec';
import { MarkdownHelpViewer } from '../../../markdown/components/help-viewer';
import { MarkdownViewport } from '../../../markdown/components/viewport';

xlationContext('Discussion plan editor preview/help panel');

interface IPresentationEditorPreviewHelpPanelProps {
  showPanel: boolean;
  showHelp: boolean;
  previewModel: ITimingSpecComponentModel[];
  previewBaseFontSize: number;
  onClosePanel: () => void;
}

export const PresentationEditorPreviewHelpPanel: React.FunctionComponent<IPresentationEditorPreviewHelpPanelProps> = (props) => {

  return (
    <BwjSidePanel
      showPanel={props.showPanel}
      title={props.showHelp ? xlate('Help') : xlate('Preview')}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: xlate('Close'),
        onClick: props.onClosePanel,
      }]}
      onDismiss={props.onClosePanel}
      closeButtonAriaLabel={xlate('Close panel')}
    >
      {props.showHelp ?
      <MarkdownHelpViewer />
      :
      <MarkdownViewport
        componentModel={props.previewModel}
        baseFontSize={props.previewBaseFontSize}
      />}
    </BwjSidePanel>
  );
};
